import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import AudioFormFillControl from "../components/audio-form-fill-control";
import Header from "../components/header";
import { SignupModelHelper } from "../data/SignupModel";
import { AmplitudeService } from '../services/AmplitudeService';

export default function Genero(props: any) {

  const [lastAnswer, setLastAnswer] = useState('');
  const [typed, setTyped] = useState(false);

  useEffect(() => {
    // TagManager.dataLayer(dataLayerHelper.pagina('genero', 'cadastro-usuario'));
    AmplitudeService.track('Gender Screen')


    const signup = SignupModelHelper.get();
    if (signup) {
      const doc = signup.document.substring(0, 3) + '.' + signup.document.substring(3, 6) + '.' + signup.document.substring(6, 9) + '-' + signup.document.substring(9, 11);
      setLastAnswer(doc);
    } else {
      document.location = './';
    }
  }, [])

  function setGender(g: string) {
    
    SignupModelHelper.update({ gender: g })
    AmplitudeService.track('Gender Selected', {gender: g})
    // TagManager.dataLayer(dataLayerHelper.measureClick('genero', g));

    document.location = '#/nascimento';
  }

  function setGenderFromAudio(values: Record<string, string>) {
    const gender = values.gender?.toLowerCase() || '';

    if (gender.indexOf('femin') !== -1) {
      setGender('Feminino');
    } else if (gender.indexOf('mascul') !== -1) {
      setGender('Masculino');
    } else {
      setGender('Prefiro não informar');
    }
  }

  return (
    <>
      <Header step={ 4 } total={ 11 } title="Seu gênero" previous="#/cpf"></Header>

      <div className="chat-container">

        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item chat-item-user">
                  <img src="images/ico-chat-user.svg" alt="Usuário" />
                  <div className="chat-item-content">
                    <p>{ lastAnswer }</p>
                  </div>
                </div>

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <p>
                      <Typewriter
                        onInit={ (typewriter) => {
                          typewriter
                            .changeDelay(15)
                            .typeString(`Por qual <strong>gênero deseja ser identificado?</strong>`)
                            .callFunction(() => {
                              setTyped(true)
                            })
                            .start();
                        } } />
                    </p>
                  </div>
                </div>

                { typed &&
                  <div className="gender-list">
                    <div className="gender-item">
                      <button className="btn btn-outline btn-full" onClick={ () => setGender('Feminino') }>Feminino</button>
                    </div>
                    <div className="gender-item">
                      <button className="btn btn-outline btn-full" onClick={ () => setGender('Masculino') }>Masculino</button>
                    </div>
                    <div className="gender-item">
                      <button className="btn btn-outline btn-full" onClick={ () => setGender('Prefiro não informar') }>Prefiro não dizer</button>
                    </div>
                    <div className="gender-item">
                      <AudioFormFillControl
                        fields={ [{ key: 'gender', label: 'Gênero' }] }
                        onApply={ setGenderFromAudio }
                        buttonTitle="Responder gênero por áudio"
                      />
                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>

      </div>

    </>);
}
